//===============================================================================
// © 2017 Lifestyle Apps.  All rights reserved.
// Original Author: Sanjeev Khanna
// Original Date: 10 June 2017
//==============================================================================

import { Injectable } from '@angular/core';
import { UserSession, UserOtherInfo } from '../models/login/index';
import { HttpHelper } from '../helpers/http.helper';
import { ErrorLog } from './error-log';

/**
 * This Class provide configurable log 
 */
@Injectable()
export class LoggingService {

    /**
     * Constructor to inject http helper
     */
    constructor(public _httpHelper: HttpHelper) {
    }

    /**
     * Method to log error detail on server
     * @param errorMsg: Error message 
     * @param methodName: Method name 
     * @param stackTrace: Stack trace 
     */
    public logErrorOnServer(errorLogModel: ErrorLog) {
        try {
        }
        catch (e) {
            this.logErrorOnConsole(e);
        }
    }

    /**
     * Method to save debug log on server
     * @param detail 
     * @param title 
     */
    public logDebugOnServer(detail: string, title: string) {
        try {
        }
        catch (e) {
            this.logErrorOnConsole(e);
        }
    }

    /**
     * Method to show message on console
     * @param error 
     */
    public logErrorOnConsole(error: string) {
        console.log(error);
    }
}


// WEBPACK FOOTER //
// /Users/hrushabhmakwana/Documents/CAM/CreditRepairMenAngular/src/app/common/logging/logging.service.ts